<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import UserProfile from "@/router/views/users/user-profile"

import AdminService from "@/services/AdminService";
import UsersDataService from "@/services/UsersDataService"

import UserUtils from '@/helpers/users';
import DateUtils from '@/helpers/date';
import Storage from "@/helpers/storage"
import {authComputed} from "@/state/helpers";

import ExpandableTextLine from 'vue-expandable-text-line'
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  name: "actions",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Logs Manager",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    ExpandableTextLine,
    VueTabs,
    VTab,
    UserProfile,
    CoolLightBox,
  },
  computed: {
    ...authComputed
  },
  methods: {
    ...UserUtils,
    ...DateUtils,

    handlePageChange(value) {
      this.page = value;
      this.loadActions();
    },

    handleDisplayChange() {
      this.loadActions();
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filters.fromDate = now.format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filters.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filters.toDate = this.filters.fromDate;
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    getRequestParams() {
      const params = {};

      params["page"] = this.page - 1;
      params["size"] = this.pageSizes.selected;

      if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
        this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filters.fromDate === null)
        this.handleDateChange();

      if (this.filters.toDate !== null)
        params['toDate'] = this.filters.toDate;

      if (this.filters.fromDate !== null)
        params['fromDate'] = this.filters.fromDate;

      params['actionType'] = this.filters.actionType.selected;
      params['actionCategory'] = this.filters.actionCategory.selected;
      params['operators'] = this.filters.operators.selected;

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    loadStats() {
      const params = this.getRequestParams();
      AdminService
          .getActionsStats(params)
          .then(response => {
            const {operators, categories, evolGraph} = response.data;

            this.operatorsGraph.series = operators.series;
            this.operatorsGraph.chartOptions = {...this.operatorsGraph.chartOptions, ...{
                labels: operators.labels
            }};

            this.categoriesGraph.series = categories.series;
            this.categoriesGraph.chartOptions = {...this.operatorsGraph.chartOptions, ...{
                labels: categories.labels
            }};

            this.$refs.actionsEvolutionChart.updateSeries([{
              name: "User",
              type: 'bar',
              data: evolGraph.user
            },{
              name: "Media",
              type: 'bar',
              data: evolGraph.media
            }, {
              name: "Ticket",
              type: 'bar',
              data: evolGraph.ticket
            }, {
              name: "Report",
              type: 'bar',
              data: evolGraph.report
            }, {
              name: "session",
              type: 'bar',
              data: evolGraph.session
            }, {
              name: "annotation",
              type: 'bar',
              data: evolGraph.annotation
            }, {
              name: "Block",
              type: 'bar',
              data: evolGraph.block
            }]);

          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("actions.errorNoResult"));
          });
    },

    getMediaThumb() {
      if (this.actions.length > 0)
        this.actions.forEach(action => {
          if (action.photo && action.photo.length > 0)
            Storage.getUserMedia(action.userId, action.photo, 'action-user-'+action.actionId);

        });
    },

    loadActions() {
      this.isLoading = true;
      const params = this.getRequestParams();
      AdminService
          .getActions(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.actions = items;
            this.count = totalItems;
            this.isLoading = false;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("actions.errorNoResult"));
            this.isLoading = false;
          });
    },

    processFilters() {
      this.loadActions();
      this.loadStats();
    },

    loadOperators() {
      AdminService
        .getOperators()
        .then(response => {
          response.data.operators.forEach(op => {
            this.filters.operators.options.push({
              value: op.documentId,
              text: op.operator
            });
          });
        })
        .catch(error => {
          window.console.log(error);
        });
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },
  mounted() {
    this.loadOperators();
    this.processFilters();
  },
  data() {
    return {
      isLoading: false,
      title: this.$t("menuitems.system.actions"),
      actions: [],
      page: 1,
      count: 0,
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '20'
      },
      operatorsGraph: {
        series:[],
        chartOptions: {
          chart: {
            id: 'actions-operators',
            type: 'donut',
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'bottom'
          },
        }
      },

      categoriesGraph: {
        series: [],
        chartOptions: {
          chart: {
            id: 'actions-categories',
            type: 'donut',
          },
          dataLabels: {
            enabled: true
          },
          labels:[],
          noData: {
            text: 'Loading...'
          },
          legend: {
            position: 'bottom'
          },
        }
      },

      evolGraph: {
        series: [],
        chartOptions: {
          chart: {
            stacked: true,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              show: true,
              style: {
                fontSize: 11
              },
              hideOverlappingLabels: true
            }
          },
          yaxis: [{
            axisTicks: {
              show: true
            },
            title: {
              text: "Nb"
            }
          }],
          colors: ["#34c38f", "#50a5f1", "#f46a6a", "#f1b44c", "#e83e8c", "#333333", "#556ee6"],

          legend: {
            position: "bottom",
          },
          fill: {
            opacity: 1,
          },
        },
      },

      filters: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'last30Day',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        actionType: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("actions.type_all")},
            {value: 'session_login', text: this.$t("actions.type_session_login")},
            {value: 'session_logout', text: this.$t("actions.type_session_logout")},
            {value: 'user_verify', text: this.$t("actions.type_user_verify")},
            {value: 'user_update-public', text: this.$t("actions.type_user_update-public")},
            {value: 'user_update-private', text: this.$t("actions.type_user_update-private")},
            {value: 'user_update-description', text: this.$t("actions.type_user_update-description")},
            {value: 'user_update-lifestyle', text: this.$t("actions.type_user_update-lifestyle")},
            {value: 'user_update-interests', text: this.$t("actions.type_user_update-interests")},
            {value: 'user_update-alerts', text: this.$t("actions.type_user_update-alerts")},
            {value: 'user_delete-token', text: this.$t("actions.type_user_delete-token")},
            {value: 'user_enable', text: this.$t("actions.type_user_enable")},
            {value: 'user_disable', text: this.$t("actions.type_user_disable")},
            {value: 'user_delete', text: this.$t("actions.type_user_delete")},
            {value: 'media_verify', text: this.$t("actions.type_media_verify")},
            {value: 'media_delete', text: this.$t("actions.type_media_delete")},
            {value: 'media_valid', text: this.$t("actions.type_media_valid")},
            {value: 'media_transform', text: this.$t("actions.type_media_transform")},
            {value: 'annotation_add', text: this.$t("actions.type_annotation_add")},
            {value: 'ticket_review', text: this.$t("actions.type_ticket_review")},
            {value: 'ticket_close', text: this.$t("actions.type_ticket_close")},
            {value: 'ticket_reply', text: this.$t("actions.type_ticket_reply")},
            {value: 'report_review', text: this.$t("actions.type_report_review")},
            {value: 'report_close', text: this.$t("actions.type_report_close")},
            {value: 'report_reply', text: this.$t("actions.type_report_reply")},
            {value: 'block_phone', text: this.$t("actions.type_block_phone")},

          ]
        },
        actionCategory: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("actions.category_all")},
            {value: 'user', text: this.$t("actions.category_user")},
            {value: 'media', text: this.$t("actions.category_media")},
            {value: 'session', text: this.$t("actions.category_session")},
            {value: 'ticket', text: this.$t("actions.category_ticket")},
            {value: 'report', text: this.$t("actions.category_report")},
            {value: 'annotation', text: this.$t("actions.category_annotation")},
            {value: 'block', text: this.$t("actions.category_block")},
          ]
        },
        operators: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("actions.operators_all")},
          ]
        }
      },

      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- Filters -->
      <div class="card">
        <div class="card-body row">
          <b-form inline class="row gy-2 gx-3 align-items-center" id="actionsFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto">
              <b-form-select
                  id="actionsDatesFilter"
                  @change="handleDateChange"
                  v-model="filters.dates.selected"
                  class="form-select me-lg-1"
                  :options="filters.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filters.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filters.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Action Category -->
            <div class="col-sm-auto">
              <b-form-select
                  id="actionsCategoryFilter"
                  v-model="filters.actionCategory.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.actionCategory.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Action Type -->
            <div class="col-sm-auto">
              <b-form-select
                  id="actionsTypeFilter"
                  v-model="filters.actionType.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.actionType.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Admin -->
            <div class="col-sm-auto">
              <b-form-select
                  id="actionsAdminFilter"
                  v-model="filters.operators.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="st in filters.operators.options" :key="st.value" :value="st.value">{{ st.text }}</option>
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Charts -->
      <div class="row">
        <!-- graph operator -->
        <div class="col-12 col-lg-3">
          <div class="card">
            <div class="card-body" id="cardActionsOperatorsChart">
              <h5 class="card-title">Operators</h5>
              <apexchart
                  ref="actionsOperatorsChart"
                  height="350"
                  type="donut"
                  dir="ltr"
                  :series="operatorsGraph.series"
                  :options="operatorsGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <!-- graph categories -->
        <div class="col-12 col-lg-3">
          <div class="card">
            <div class="card-body" id="cardActionsCategoriesChart">
              <h5 class="card-title">Categories</h5>
              <apexchart
                  ref="actionsCategoriesChart"
                  height="350"
                  type="donut"
                  dir="ltr"
                  :series="categoriesGraph.series"
                  :options="categoriesGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <!-- graph evol -->
        <div class="col-12 col-lg-6">
          <div class="card">
            <div class="card-body" id="cardActionsEvolChart">
              <h5 class="card-title">Evolution</h5>
              <apexchart
                  ref="actionsEvolutionChart"
                  height="300"
                  type="bar"
                  dir="ltr"
                  :series="evolGraph.series"
                  :options="evolGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>

          {{ count }} {{ $t('resultsCount') }}
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="actions-list"
            ></b-pagination>
          </div>
        </div>
      </div>

      <!-- Result list -->
      <div class="row bg-white" v-if="!isLoading && actions.length > 0">
        <div class="table-responsive">
          <table
              class="table project-list-table table-nowrap table-centered table-borderless align-middle"
          >
            <thead>
            <tr>
              <th scope="col">{{ $t('actions.actionAt') }}</th>
              <th scope="col" style="min-width:150px">{{ $t('actions.operator') }}</th>
              <th scope="col">{{ $t('actions.category') }}</th>
              <th scope="col">{{ $t('actions.type') }}</th>
              <th scope="col">{{ $t('actions.user') }}</th>
              <th scope="col">{{ $t('actions.data1') }}</th>
              <th scope="col">{{ $t('actions.data2') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="action in actions" :key="action.actionId">
              <td>
                <p class="text-muted font-size-12">{{ formatDateString(action.actionAt, 'DD MMM YYYY HH:mm') }}</p>
              </td>
              <td>
                <div class="media align-items-center">
                  <div class="avatar-xs">
                      <span
                          class="avatar-title rounded-circle font-size-15 bg-light text-dark"
                      >{{ getInitials(action.operator) }}</span>
                  </div>
                  <div class="media-body ms-2">
                    {{ action.operator }}
                  </div>
                </div>
              </td>
              <td>
                <span
                    class="badge"
                    :class="{
                          'bg-success': `${action.actionCategory}` === 'user',
                          'bg-warning': `${action.actionCategory}` === 'report',
                          'bg-danger': `${action.actionCategory}` === 'ticket',
                          'bg-info': `${action.actionCategory}` === 'media',
                          'bg-primary': `${action.actionCategory}` === 'block',
                          'bg-pink': `${action.actionCategory}` === 'session',
                          'bg-dark': `${action.actionCategory}` === 'annotation',
                        }"
                >{{ $t(`actions.category_${action.actionCategory}`) }}</span
                >
              </td>
              <td>
                <span class="font-size-12 text-muted fw-bold">
                  {{ action.actionType }}
                </span>
              </td>
              <td>
                <div class="media media-user" v-if="action.userId !== '-'" @click="showUser(action.userId)">
                  <div class="avatar-xs">
                    <img
                        :id="`action-user-${action.actionId}`"
                        :src="require('@/assets/images/users/default-user.png')"
                        class="d-flex rounded-circle avatar-xs" />
                  </div>
                  <div class="media-body ms-2">
                    <h5 class="font-size-14 mb-0">
                        <span
                            :class="{
                            'text-primary': action.sex === 1,
                            'text-danger': action.sex === 2,
                            'text-dark': action.sex === 0,
                          }"
                        >
                          {{ action.name || '-' }}
                        </span> {{ getAge(action.birth) }}</h5>
                    <small class="text-muted">#{{ action.userId }}</small>
                  </div>
                </div>
                <p class="text-muted" v-else> - </p>
              </td>
              <td>
                <expandable-text-line use-click class="font-size-12 text-muted">{{ action.data1 }}</expandable-text-line>
              </td>
              <td>
                <expandable-text-line use-click>{{ action.data2 }}</expandable-text-line>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Result Empty -->
      <div class="row" v-if="!isLoading && actions.length === 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No Actions were found for these filters. Try again.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="actions-list"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
    <vue-tabs
        v-model="userTabsActive"
        active-tab-color="#213213"
        active-text-color="white">
      <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
        <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
        <UserProfile
            :userId="null"
            :user="userTab"
            v-on:SHOW_MEDIA="showUserMedia">
        </UserProfile>
      </v-tab>
    </vue-tabs>
    </b-sidebar>

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>
.media-user {
  cursor: pointer;
}

.b-sidebar-right {
  width:35%;
}

.b-sidebar-body {
  padding:16px;
}
</style>
